import { logger } from '@disy/lib/logging';
import type { MenuItemGroup } from '@disy/ui/menu';

import type { ActionOptions } from 'cadenza/action';
import { Action } from 'cadenza/action';

/**
 * The base class for actions with a menu.
 */
export class MenuAction extends Action {
  readonly #actionProvider;

  constructor(actionProvider: () => (Action | MenuItemGroup)[], options: ActionOptions) {
    super(options);
    this.#actionProvider = actionProvider;
  }

  override executeSync() {
    // No work to be done: We just open the action
  }

  get actionProvider() {
    return this.#actionProvider;
  }

  override async isSupported(context: unknown): Promise<boolean> {
    let unsupportedCount = 0;
    const providedActions = this.actionProvider();
    for (const action of providedActions) {
      if (isMenuItemGroup(action)) {
        continue;
      }
      try {
        if (await (action as Action).isSupported(context)) {
          return true;
        }
        unsupportedCount++;
        if (unsupportedCount === providedActions.length) {
          return false;
        }
      } catch (reason) {
        logger.error('Cannot check add layer action', reason);
      }
    }
    return false;
  }
}

export function isMenuItemGroup(action: Action | MenuItemGroup): action is MenuItemGroup {
  return !!(action as MenuItemGroup).group;
}

export function unpackMenuItemGroups(
  menuActions: (Action | MenuItemGroup)[],
  separator = false,
): (Action | MenuItemGroup)[] {
  return menuActions.map((action) =>
    isMenuItemGroup(action) ? { label: action.label, group: action.group, separator } : action,
  );
}
